import { pushToDataLayer } from './src/utils/dataLayer'

export const onRouteUpdate = () =>
	pushToDataLayer({
		event: 'gatsby-route-change',
	})
